import { BlcLoader, Body, FlexBox, Headline } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';

const PaymentMethodsLoading = () => {
	const { t } = useTranslation(['signup']);

	return (
		<FlexBox
			alignItems="center"
			flexDirection="column"
			gap="lg"
			justifyContent="center"
			minHeight={280}
			padding="xl"
			role="status"
		>
			<BlcLoader size="larger" />
			<FlexBox alignItems="center" flexDirection="column" gap="xs">
				<Headline size="H2" textAlign="center">
					{t('signup:auctionAccessLookup.paymentMethodsStep.preparing.title')}
				</Headline>
				<Body color="secondary" textAlign="center">
					{t('signup:auctionAccessLookup.paymentMethodsStep.preparing.subTitle')}
				</Body>
			</FlexBox>
		</FlexBox>
	);
};

export default PaymentMethodsLoading;
